import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import EmployeeUserModule from "@/store/modules/employeeuser.module";
import { ClockWorkModule } from "@/store/modules/clockWork.module";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import { TimeReportModel } from "@/store/models/clockWork/timeReport";
import Timer from "@/components/clockWork/timer.vue";
import simplebar from "simplebar-vue";
import _ from "lodash";
import EcSelect from "@/components/widgets/EcSelect.vue";
import Switches from "vue-switches";
Component.registerHooks(["metaInfo"]);
let TimeReport = /** @class */ (() => {
    let TimeReport = class TimeReport extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Time Report";
            this.pageIsLoading = false;
            this.isPageLoading = false;
            this.SubmitButton = false;
            this.showText = true;
            this.date = null;
            this.employeeId = "";
            this.selected = [];
            this.timeReport = new TimeReportModel();
            this.showTable = false;
            this.reportType = false;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Reports",
                },
                {
                    text: "Time Report",
                    active: true,
                },
            ];
        }
        get employeeUsers() {
            return EmployeeUserModule.employeeUsers;
        }
        get entries() {
            return ClockWorkModule.timeReportClockWorkEntries;
        }
        get cumulativeEntries() {
            return ClockWorkModule.cumulativeTimeReportClockWorkEntries;
        }
        get totalTime() {
            var totalTimeInSeconds = ClockWorkModule.totalTime;
            const hours = Math.floor(totalTimeInSeconds / 3600);
            const minutes = Math.floor((totalTimeInSeconds % 3600) / 60);
            if (hours === 0) {
                return `${minutes}m`;
            }
            else {
                const formattedTime = `${hours}h ${minutes}m`;
                return formattedTime;
            }
        }
        get projectList() {
            return _.sortBy(ClockWorkModule.validProject, (item) => parseInt(item.code));
        }
        submit() {
            this.validate("validateObserver").then((res) => {
                if (res) {
                    this.pageIsLoading = true;
                    this.showText = false;
                    if (this.timeReport.date[0] != null && this.timeReport.date != undefined) {
                        this.timeReport.startDate = this.timeReport.date[0];
                        console.log(this.timeReport.date, this.timeReport.startDate);
                        this.timeReport.startDateAsString = this.dateFormattedString(this.timeReport.date[0]);
                        this.timeReport.endDate = this.timeReport.date[1];
                        this.timeReport.endDateAsString = this.dateFormattedString(this.timeReport.date[1]);
                        this.timeReport.projectIds = this.selected.map((item) => item.id);
                        this.timeReport.isCumulative = this.reportType;
                        ClockWorkModule.GetUserTimeReport(this.timeReport).then((res) => {
                            if (res) {
                                this.showTable = true;
                                this.pageIsLoading = false;
                            }
                        });
                    }
                }
            });
        }
        GenerateTimeReportAsExcel() {
            this.validate("validateObserver").then((res) => {
                if (res) {
                    this.isPageLoading = true;
                    this.timeReport.startDate = this.timeReport.date[0];
                    this.timeReport.startDateAsString = this.dateFormattedString(this.timeReport.date[0]);
                    this.timeReport.endDate = this.timeReport.date[1];
                    this.timeReport.endDateAsString = this.dateFormattedString(this.timeReport.date[1]);
                    this.timeReport.isCumulative = this.reportType;
                    ClockWorkModule.GetUserTimeReportAsExcel(this.timeReport).then((res) => {
                        if (res) {
                            const blob = new Blob([res], {
                                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            });
                            const link = document.createElement("a");
                            link.href = window.URL.createObjectURL(blob);
                            document.body.appendChild(link);
                            link.download = `TimeReport.xlsx`;
                            link.click();
                            this.isPageLoading = false;
                        }
                    });
                }
            });
        }
        getProjects() {
            if (this.timeReport.date[0] != null && this.timeReport.date != undefined) {
                this.timeReport.startDate = this.timeReport.date[0];
                this.timeReport.startDateAsString = this.dateFormattedString(this.timeReport.date[0]);
                this.timeReport.endDate = this.timeReport.date[1];
                this.timeReport.endDateAsString = this.dateFormattedString(this.timeReport.date[1]);
                ClockWorkModule.GetProjectsInGivenTimePeriod(this.timeReport).then((res) => {
                    if (res) {
                        this.SubmitButton = true;
                    }
                });
            }
        }
        selectionChanged(selectedObjects) {
            if (selectedObjects.id == this.emptyGuid) {
                this.selected = [];
                this.selected.push(selectedObjects);
            }
            else {
                this.selected = this.selected.filter((x) => x.id != this.emptyGuid);
                this.selected.push(selectedObjects);
            }
        }
        clearDatePicker() {
            ClockWorkModule.ClearData();
        }
        clearReport() {
            this.SubmitButton = false;
            this.showTable = false;
            this.timeReport.date = null;
            this.timeReport.employeeId = "";
            this.showText = true;
            this.timeReport.projectIds = [];
            this.selected = [];
            this.reportType = false;
            this.timeReport.isCumulative = false;
            ClockWorkModule.ClearData();
        }
        created() {
            EmployeeUserModule.GetAllEmployeeUsers().then((res) => {
                if (res) {
                    this.pageIsLoading = false;
                }
            });
        }
        destroyed() {
            this.clearDatePicker();
        }
    };
    TimeReport = __decorate([
        Component({
            name: "TimeReport",
            components: {
                Loader,
                Layout,
                Timer,
                PageHeader,
                SectionLoader,
                EcSelect,
                simplebar,
                Switches,
            },
        })
    ], TimeReport);
    return TimeReport;
})();
export default TimeReport;
